import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

/**
 * Safely extract a human-readable error message from an axios error.
 * FastAPI can return detail as string OR array of {type, loc, msg, ...}.
 */
export const getErrMsg = (err) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || JSON.stringify(d)).join(", ");
  }
  if (detail && typeof detail === "object") return JSON.stringify(detail);
  return err?.message || "Request failed";
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("frontera_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("frontera_token");
    }
    return Promise.reject(err);
  }
);
